const urlSearch = typeof window !== 'undefined' ? window?.location?.search : '';
const searchParams = new URLSearchParams(urlSearch);
const isDraftProduct = Boolean(searchParams.get('draftProductId'));
export default isDraftProduct;
